function initializeCollectionSwiper(containerId, centeredSlides = false) {
  var containerSelector = '#' + containerId;
  var allSwipers = [];
  const container = document.querySelector(containerSelector);

  if (container == null) {
    return;
  }
  container.querySelectorAll('.collection-swiper').forEach(function (el, index) {
    const mobileColumns = el.getAttribute('data-mobile-columns');
    const desktopColumns = el.getAttribute('data-desktop-columns');
    allSwipers[index] = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 30,
      scrollbar: {
        el: container.querySelector('.swiper-scrollbar-' + index),
        draggable: true,
      },
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis: true,
      },
      breakpoints: {
        320: {
          slidesPerView: mobileColumns,
          spaceBetween: 20,
          centeredSlides
        },
        640: {
          slidesPerView: desktopColumns,
          spaceBetween: 40
        }
      }
    });
  });

  container.querySelectorAll('.tab-link').forEach(function (el) {
    el.addEventListener('click', function () {
      const collectionId = this.getAttribute('data-target');
      container.querySelectorAll('.tab-content').forEach(function (el) {
        el.style.display = 'none';
      });
      const collection = container.querySelector('#' + collectionId);
      collection.style.display = 'block';

      container.querySelectorAll('.tab-link').forEach(function (el) {
        el.classList.remove('active');
      });

      this.classList.add('active');

      container.querySelectorAll('.collection-button').forEach(function (el) {
        const linkCollectionId = el.getAttribute('data-target');
        if (linkCollectionId !== collectionId) {
          el.classList.remove('active');
        }
        else {
          el.classList.add('active');
        }
      });
      const swiper = collection.querySelector('.collection-swiper');
      swiper.update();


      // allSwipers.forEach(function (swiper) {
      //   swiper.update();
      // });
    });
  });
}